<span [attr.data-qa]="appTestTag() ? appTestTag() : 'file-name-' + baseFileName()" class="base-filename">{{ baseFileName() }}</span>
@let fileExt = fileExtension();
@if (fileExt) {
    <span [attr.data-qa]="'file-extension-' + fileExt">{{ fileExt }}</span>
}
